<template>
	<div>
		<a-modal wrap-class-name="report-detail-modal-wrapper" width="702px" :mask-closable="false" :visible="visible"
			:footer="null" :title="title" @cancel="$emit('onCancel')" style="top: 20px" :bodyStyle="setModalStyle()">
			<div class="orginfo-wrapper" ref="orginfoWrapper">
				<div class="flex-item-wrapper" 
					v-if="data.workList && (data.workList.service_info.name == '调研' || data.workList.service_info.name == '拜访')">
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							医生姓名:
						</p>
						<p class="flex-item-right">
							{{ data.doctor?data.doctor.user_realname:'' }}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							医院名称:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_hospital[0]?data.workReportDetail.report_hospital[0].name:'' }}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							{{data.workList.service_info.name=='拜访'?'拜访科室:':'调研科室:'}}
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_department}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							{{data.workList.service_info.name=='拜访'?'拜访名称:':'调研名称:'}}
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.title}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							{{data.workList.service_info.name=='拜访'?'拜访开始时间:':'调研开始时间:'}}
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.start_time}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							{{data.workList.service_info.name=='拜访'?'拜访结束时间:':'调研结束时间:'}}
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.end_time}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;"
						v-if="data.workList && data.workList.service_info.name=='拜访'">
						<p class="flex-item-left grid-left-col">
							拜访目的:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.purpose_text}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							学习资料:
						</p>
						<p class="flex-item-right">
							【{{data.map_id.link_datas.obj_type_text}}】{{ data.map_id.link_datas.name}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<div class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.sign_picture?'height:169px':''">
							签到打卡:
						</div>
						<div class="flex-item-right">
							
							<p><img :src="data.workReportDetail.report_value.sign_picture"
									style="width: 100px;height: 100px;"
									@click="handlePreviewSingle(data.workReportDetail.report_value.sign_picture)"></p>
							<p style="margin-bottom: 0;">签到地址：{{ data.workReportDetail.report_value.sign_address}}</p>
						</div>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.pictures.length?'height:105px':''">
							{{data.workList.service_info.name=='拜访'?'现场照片(非必填):':'调研表照片:'}}
						</p>
						
						<p class="flex-item-right">
							<img :src="item" v-for="(item,index) in data.workReportDetail.report_value.pictures"
								style="width: 100px;height: 100px;"
								@click="handlePreviewSingle(item)" :key="index">
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;"
						v-if="data.workList.service_info.name=='拜访'">
						<p class="flex-item-left grid-left-col">
							医生反馈:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.feedback_text}}
						</p>
					</div>
				</div>
				
				<!-- 区域市场政策信息收集 -->
				<div class="flex-item-wrapper"
					v-if="data.workList && data.workList.service_info.name=='区域市场政策信息收集'">
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							收集日期:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.start_time }}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							收集地区:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_city }}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							信息发布单位:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.publish_organization}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							政策内容:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.policy_list}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">

						<div class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.image_ext?'height:119px':''">
							政策信息:
						</div>
						<div class="flex-item-right">
								<img :src="item" v-for="(item,index) in data.workReportDetail.report_value.image_ext"
								style="width: 100px;height: 100px;margin-right: 10px;"
								@click="handlePreviewSingle(item)" :key="index">
						</div>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							主要内容说明:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.main_content}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							对产品的影响:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.product_affect}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;"
						>
						<p class="flex-item-left grid-left-col">
							提出建议:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.suggest}}
						</p>
					</div>
					
				</div>

				<!-- 终端机构准入服务" -->
				<div class="flex-item-wrapper"
					v-if="data.workList && data.workList.service_info.flag=='access'">
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							推广产品:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.product_name }}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							医疗机构名称:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.organization_name }}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							医疗机构等级:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.organization_level}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							服务内容:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.service_list}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							工作天数:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.work_days}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;"
						>
						<p class="flex-item-left grid-left-col">
							工作成果:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.achievement}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;"
						>
						<p class="flex-item-left grid-left-col">
							商业公司名称:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.business_name}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							价格(元):
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.price}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							数量:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.num}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							配送日期:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.delivery_date}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.image_ext.length?'height:102px':''">
							流向数据证明:
						</p>
						<p class="flex-item-right"><img :src="item" v-for="(item,index) in data.workReportDetail.report_value.image_ext"
								style="width: 100px;height: 100px;margin-right: 10px;"
								@click="handlePreviewSingle(item)" :key="index">
						</p>
					</div>
				</div>

				<!-- 科室会 -->
				<div class="flex-item-wrapper"
					v-if="data.workList && data.workList.service_info.name=='科室会'">
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							会议名称:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.title }}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							会议开始时间:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.start_time }}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							会议结束时间:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.end_time}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							会议城市:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_city}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							参会人数:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.join_meeting_num}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							举办医院:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_hospital[0].name}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;"
						>
						<p class="flex-item-left grid-left-col">
							参会科室:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_department}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;"
						>
						<p class="flex-item-left grid-left-col">
							备注:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.notice}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							学习资料:
						</p>
						<p class="flex-item-right">
							【{{ data.map_id.link_datas.obj_type_text}}】{{ data.map_id.link_datas.name}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<div class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.sign_picture?'height:169px':''">
							签到打卡:
						</div>
						<div class="flex-item-right">
							<p><img :src="data.workReportDetail.report_value.sign_picture"
									style="width: 100px;height: 100px;"
									@click="handlePreviewSingle(data.workReportDetail.report_value.sign_picture)"></p>
							<p>签到地址：{{ data.workReportDetail.report_value.sign_address}}</p>
						</div>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.mark_picture.length?'height:102px':''">
							签到表:
						</p>
					
						<p class="flex-item-right"><img :src="item" v-for="(item,index) in data.workReportDetail.report_value.mark_picture"
								style="width: 100px;height: 100px;margin-right: 10px;"
								@click="handlePreviewSingle(item)" :key="index">
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.pictures.length?'height:102px':''">
							现场照片:
						</p>
						
						<p class="flex-item-right"><img :src="item" v-for="(item,index) in data.workReportDetail.report_value.pictures"
								style="width: 100px;height: 100px;margin-right: 10px;"
								@click="handlePreviewSingle(item)" :key="index">
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.invite_picture.length?'height:102px':''">
							会议通知/邀请函:
						</p>
						
						<p class="flex-item-right"><img :src="item" v-for="(item,index) in data.workReportDetail.report_value.invite_picture"
								style="width: 100px;height: 100px; margin-right: 10px;"
								@click="handlePreviewSingle(item)" :key="index">
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<div class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.sign_picture?'height:149px':''">
							会议记录以及报告上传:
						</div>
						<div class="flex-item-right">
							<div v-show="data.workReportDetail.report_value.sign_address">
								<p>
									<img :src="item" v-for="(item,index) in data.workReportDetail.report_value.report_picture"
								style="width: 100px;height: 100px;"
								@click="handlePreviewSingle(item)" :key="index" />	
								</p>
								<p>{{data.workReportDetail.report_value.meeting_report}}</p>
							</div>
							<div v-show="!data.workReportDetail.report_value.sign_address">-</div>
						</div>
					</div>
				</div>
				
				<!-- 沙龙会 -->
				<div class="flex-item-wrapper"
					v-if="data.workList && data.workList.service_info.name=='沙龙会'">
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							会议名称:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.title }}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							会议开始时间:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.start_time }}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							会议结束时间:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.end_time}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							会议城市:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_city}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							参会人数:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.join_meeting_num}} 人
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							举办医院:
						</p>
						<p class="flex-item-right">
							<span v-for="(item,index) in data.workReportDetail.report_hospital" :key="index">{{item.name}}</span>
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;"
						>
						<p class="flex-item-left grid-left-col">
							参会科室:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_department}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;"
						>
						<p class="flex-item-left grid-left-col">
							备注:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.notice}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							学习资料:
						</p>
						<p class="flex-item-right">
							【{{ data.map_id.link_datas.obj_type_text}}】{{ data.map_id.link_datas.name}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<div class="flex-item-left grid-left-col"  :style="data.workReportDetail.report_value.sign_picture?'height:169px':''">
							签到打卡:
						</div>
						<div class="flex-item-right">
							<p><img :src="data.workReportDetail.report_value.sign_picture"
									style="width: 100px;height: 100px;"
									@click="handlePreviewSingle(data.workReportDetail.report_value.sign_picture)"></p>
							<p>签到地址：{{ data.workReportDetail.report_value.sign_address}}</p>
						</div>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.mark_picture?'height:114px':''">
							签到表:
						</p>
						<p class="flex-item-right">
							<img :src="item" v-for="(item,index) in data.workReportDetail.report_value.mark_picture"
							style="width: 100px;height: 100px;"
							@click="handlePreviewSingle(item)" :key="index" />
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.pictures?'height:114px':''">
							现场照片:
						</p>
						<p class="flex-item-right">
							<img :src="item" v-for="(item,index) in data.workReportDetail.report_value.pictures"
								style="width: 100px;height: 100px;"
								@click="handlePreviewSingle(item)" :key="index" />
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.invite_picture?'height:114px':''">
							会议通知/邀请函:
						</p>
						<p class="flex-item-right">
							<img :src="item" v-for="(item,index) in data.workReportDetail.report_value.invite_picture"
								style="width: 100px;height: 100px;"
								@click="handlePreviewSingle(item)" :key="index" />
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.report_picture?'height:114px':''">
							会议记录以及报告上传:
						</p>
						<p class="flex-item-right">
							<img :src="item" v-for="(item,index) in data.workReportDetail.report_value.report_picture"
								style="width: 100px;height: 100px;"
								@click="handlePreviewSingle(item)" :key="index"/>
						</p>
					</div>
				</div>

				<!-- 数据流向 -->
				<div class="flex-item-wrapper"
					v-if="data.workList && data.workList.service_info.name=='数据流向收集'">
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							收集日期:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.start_time }}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							收集地区:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_city}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							产品名称:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.product_names}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							规格/剂型:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.form_drug}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							批号:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.batch_number}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							有效期:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.indate}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							销售日期:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.sale_date}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							计量单位:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.unit}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							流向数量:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.num}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							总价(元):
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.total_price}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							商业公司名称:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.business_name}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							终端名称:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.client_name}}
						</p>
					</div>
					
				</div>
				
				<!-- 在线调研 -->
				<div class="flex-item-wrapper"
					v-if="data.workList && data.workList.service_info.name=='市场调研'">
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							调研时间
						</p>
						<p class="flex-item-right">
							{{ data.task_submit_time}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							使用资料:
						</p>
						<p class="flex-item-right">
							【{{data.map_id.link_datas.obj_type_text}}】{{ data.map_id.link_datas.name}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<div class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.sign_picture?'height:139px':''">
							签到打卡:
						</div>
						<div class="flex-item-right">
							<div v-show="data.workReportDetail.report_value.sign_address">
								<p>
									<img :src="data.workReportDetail.report_value.sign_picture"
										style="width: 90px;height: 90px;"
										@click="handlePreviewSingle(data.workReportDetail.report_value.sign_picture)"></p>
								<p>签到地址：{{ data.workReportDetail.report_value.sign_address}}</p>
							</div>
							<div v-show="!data.workReportDetail.report_value.sign_address">-</div>
						</div>
					</div>
					
				</div>

				<!-- 竞品信息收集 -->
				<div class="flex-item-wrapper"
					v-if="data.workList && data.workList.service_info.name=='竞品信息收集'">
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							收集日期
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.start_time}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							终端医院名称:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.terminal_name}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							目标产品:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.aim_name}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							所在城市:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_city}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							医院级别:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.hospital_gradelevel}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							目标产品单价(元):
						</p>
						<p class="flex-item-right">
							¥ {{ data.workReportDetail.report_value.aim_price}} 元
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							目标类产品在目标市场的概况:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.circumstance}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							竞品生产企业:
						</p>
						<p class="flex-item-right"> 
							{{ data.workReportDetail.report_value.competitive_factory_name}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							竞品名称:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.competitive_product_name}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							单价(元):
						</p>
						<p class="flex-item-right">
							¥ {{ data.workReportDetail.report_value.competitive_product_price}} 元
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							竞品覆盖科室:
						</p>
						<p class="flex-item-right">
							{{ multipleValJoin(data.workReportDetail.report_value.department_names)}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							竞品资料:
						</p>
						<p class="flex-item-right">
							<img :src="showFilePic(item)" v-for="(item,index) in data.workReportDetail.report_value.file_ext"
								style="width: 28px;height: 28px;display: inline-block;margin-right: 5px;border-radius: 3px;"
								@click="handlePreviewFile(item)" :key="index" />
								
							<img :src="item" v-for="(item,index) in data.workReportDetail.report_value.image_ext"
								style="width: 28px;height: 28px;display: inline-block;margin-right: 5px;border-radius: 3px;"
								@click="handlePreviewSingle(item)" :key="index" />
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							销售模式:
						</p>
						<p class="flex-item-right">
							<span class="option-block" v-for="(item,index) in defaultServiceConfigs.sale_model.core_client.children" :key="index">
								{{ item.name == data.workReportDetail.report_value.sale_model_core ? '(√)' : '()'}} 
								{{ item.name }}；</span>
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" style="height: 86px;">
							销售策略-方式:
						</p>
						<p class="flex-item-right">
							<span class="option-block" v-for="(item,index) in defaultServiceConfigs.sales_strategy.way.children" :key="index">
								{{ data.workReportDetail.report_value.sales_strategy_way.includes(item.name) ? '(√)' : '()'}} 
								{{ item.name }}；</span>
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" style="height: 65px;">
							销售策略-策略:
						</p>
						<p class="flex-item-right">
							<span class="option-block" v-for="(item,index) in defaultServiceConfigs.sales_strategy.strategy.children" :key="index">
								{{ data.workReportDetail.report_value.sales_strategy_tactics.includes(item.name) ? '(√)' : '()'}} 
								{{ item.name }}；</span>
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" style="height: 44px;">
							终端地区政策:
						</p>
						<p class="flex-item-right">
							<span class="option-block" v-for="(item,index) in defaultServiceConfigs.terminal_policy.children" :key="index">
								{{ data.workReportDetail.report_value.terminal_policy.includes(item.name) ? '(√)' : '()'}} 
								{{ item.name }}；</span>
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" style="height: 170px;">
							竞品分析-优势:
						</p>
						<p class="flex-item-right">
							<span class="option-block" v-for="(item,index) in defaultServiceConfigs.competitor_swot.strengths.children" :key="index">
								{{ data.workReportDetail.report_value.competitor_swot_strengths.includes(item.name) ? '(√)' : '()'}} 
								{{ item.name }}；</span>
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" style="height: 149px;">
							竞品分析-劣势:
						</p>
						<p class="flex-item-right">
							<span class="option-block" v-for="(item,index) in defaultServiceConfigs.competitor_swot.weaknesses.children" :key="index">
								{{ data.workReportDetail.report_value.competitor_swot_weaknesses.includes(item.name) ? '(√)' : '()'}} 
								{{ item.name }}；</span>
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" style="height: 128px;">
							竞品分析-机会:
						</p>
						<p class="flex-item-right">
							<span class="option-block" v-for="(item,index) in defaultServiceConfigs.competitor_swot.opportunities.children" :key="index">
								{{ data.workReportDetail.report_value.competitor_swot_opportunities.includes(item.name) ? '(√)' : '()'}} 
								{{ item.name }}；</span>
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" style="height: 65px;">
							竞品分析-威胁:
						</p>
						<p class="flex-item-right">
							<span class="option-block" v-for="(item,index) in defaultServiceConfigs.competitor_swot.threats.children" :key="index">
								{{ data.workReportDetail.report_value.competitor_swot_threats.includes(item.name) ? '(√)' : '()'}} 
								{{ item.name }}；</span>
						</p>
					</div>
				</div>

				<!-- 客户拜访/商业渠道维护 -->
				<div class="flex-item-wrapper"
					v-if="data.workList && data.workList.service_info.flag==='terminalcall'">
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							拜访开始时间
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.start_time}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							拜访结束时间:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.end_time}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							客户名称:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.business_name}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" style="height: 65px;">
							沟通内容:
						</p>
						<p class="flex-item-right">
							<span class="option-block" v-for="(item,index) in defaultServiceConfigs.discuss_target.options.children" :key="index">
								{{ data.workReportDetail.report_value.discuss_target.includes(item.name) ? '(√)' : '()'}} 
								{{ item.name }}；
							</span>
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							达成情况:
						</p>
						<p class="flex-item-right" v-if="data.workReportDetail.report_value.gain_target==='其他'">
							{{ data.workReportDetail.report_value.gain_target}}（{{ data.workReportDetail.report_value.gain_target_other_content}}）
						</p>
						<p class="flex-item-right" v-else>
							{{ data.workReportDetail.report_value.gain_target}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;" v-if="data.map_id.link_datas.name">
						<p class="flex-item-left grid-left-col">
							使用资料:
						</p>
						<p class="flex-item-right">
							【{{data.map_id.link_datas.obj_type_text}}】{{ data.map_id.link_datas.name}}
						</p>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<div class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.sign_picture?'height:139px':''">
							签到打卡:
						</div>
						<div class="flex-item-right">
							<div v-show="data.workReportDetail.report_value.sign_address">
								<p>
									<img :src="data.workReportDetail.report_value.sign_picture"
										style="width: 90px;height: 90px;"
										@click="handlePreviewSingle(data.workReportDetail.report_value.sign_picture)"></p>
								<p>签到地址：{{ data.workReportDetail.report_value.sign_address}}</p>
							</div>
							<div v-show="!data.workReportDetail.report_value.sign_address">-</div>
						</div>
					</div>
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col" :style="data.workReportDetail.report_value.pictures.length?'height:102px':''">
							现场照片:
						</p>
						
						<p class="flex-item-right"><img :src="item" v-for="(item,index) in data.workReportDetail.report_value.pictures"
								style="width: 100px;height: 100px;margin-right: 10px;"
								@click="handlePreviewSingle(item)" :key="index">
						</p>
					</div>
					
					<div class="flex-item-content" style="display: flex;align-items: center;">
						<p class="flex-item-left grid-left-col">
							备注:
						</p>
						<p class="flex-item-right">
							{{ data.workReportDetail.report_value.feedback}}
						</p>
					</div>
				</div>


			</div>

			<div v-if="data.workList && data.workList.service_info.flag==='onlinesurvey'">
			<div class="report-window" ></div>
			<iframe width="100%" :style="{height: iframeHeight}" :src="data.jump_url" />
			</div>
		</a-modal>
		<a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
			<img alt="example" style="width: 100%" :src="previewImage">
		</a-modal>
	</div>
</template>

<script>
export default {
  props: ["title", "visible", "data",'defaultServiceConfigs'],
  data() {
    return {
      previewVisible: false,
      previewImage: "",
      iframeHeight: 0,
	  docFile: require("./../../../../assets/doc.png"),
	  pdfFile: require("./../../../../assets/pdf.png"),
    };
  },
  watch: {
    visible: function () {
      this.$nextTick(() => {
        let that = this;
        setTimeout(function () {
          let offsetHeight = that.$refs.orginfoWrapper.offsetHeight + 210;
          that.iframeHeight = `calc(100vh - ${offsetHeight}px)`;
        }, 200);
      });
    },
  },
  mounted() {},
  methods: {
	multipleValJoin(val){
		return val ? val.join('；'):'';
	},
	showFilePic(item){
		let fileLog = '';
		switch(item.ext){
			case 'doc':
				fileLog = this.docFile;
			break;
			case 'pdf':
			fileLog = this.pdfFile;
			break;
		};
		return fileLog;
	},
    setModalStyle() {
      let mstyle = {};
      if (
        this.data.workList &&
        this.data.workList.service_info.flag === "onlinesurvey"
      ) {
        mstyle = { height: "calc(100vh - 130px)" };
      } else {
        // mstyle = { maxHeight: "calc(100vh - 130px)" };
      }
      return mstyle;
    },
    // 多图片预览
    handlePreview(img) {
      this.previewVisible = true;
      this.previewImage = img;
    },
    // 单张图片预览
    handlePreviewSingle(url) {
      this.previewVisible = true;
      this.previewImage = url;
    },
	handlePreviewFile(item){
		window.open(item.file);
	},
    // 关闭预览
    handleCancel() {
      this.previewVisible = false;
    },
  },
};
</script>
<style>
.ant-modal-body {
  padding-bottom: 24px !important;
  margin-top:0 !important;
  padding-top: 10px !important;
}
</style>
<style lang="scss" scoped>
.report-window {
  border-top: 1px dashed #666;
  margin: 15px auto;
}
.option-block{
	// display: block;
}
iframe {
  border: none;
}
.report-detail-modal-wrapper {
  .report-detail-row {
    padding: 0 50px;

    &.bottom {
      padding-bottom: 50px;
    }
  }

  .report-detail-label {
    padding: 15px 0;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(195, 199, 213, 1);
  }

  .report-detail-value {
    padding: 15px 0;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
  }

  .report-detail-mobile {
    position: relative;
    text-align: right;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(195, 199, 213, 1);
    height: 30px;
    line-height: 30px;

    .line {
      margin-top: 15px;
      float: left;
      height: 1px;
      width: 570px;
      background: rgba(239, 240, 247, 1);
    }

    .text {
      float: right;
    }
  }
}

.grid-left-col {
  width: 200px;
  background: #f5f7fa;
  margin: 0 0 2px 0;
  height: 30px;
  line-height: 30px;
  padding-right: 10px;
  text-align: right;
}
.flex-item-right {
  margin: 0 0 2px 0;
  padding-left: 10px;
  width: 550px;
}
</style>
